var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "section operations" }, [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                !_vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.editCustomEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                    )
                  : _vm._e(),
                !_vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.delRuleEvent }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.DeleteConfiguration")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveCustomEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                    )
                  : _vm._e(),
                _vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "default" },
                        on: { click: _vm.cancelCustomEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { no: "onDownloadTemplate", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.onDownloadTemplate()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DownloadPortServiceScope")))]
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "form-column" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.PushCondition"))),
              _c("i", {
                staticClass: "el-icon-question",
                attrs: {
                  title: _vm.$t(
                    "SystemMaintenance.DataCargoTrackingPurchaseEffect"
                  )
                }
              })
            ]),
            _c(
              "el-form",
              {
                attrs: {
                  "label-width": "100px",
                  "label-position": "left",
                  disabled: !_vm.isEdit
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SystemMaintenance.PushFCLLCLType") }
                  },
                  [
                    _c("cargo-advance-select", {
                      ref: "containerLoadType",
                      staticStyle: { width: "300px" },
                      attrs: {
                        clearable: false,
                        multiple: "",
                        "default-multiple-value": _vm.containerLoadTypes,
                        "static-options": _vm.containerLoadTypesList,
                        "tag-value": "code",
                        placeholder: _vm.isEdit
                          ? _vm.$t("SystemMaintenance.PleaseSelectFCLLCLType")
                          : " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.cargoTypeChange(p)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-config-more" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-width": "100px",
                      "label-position": "left",
                      disabled: !_vm.isEdit
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SystemMaintenance.DoServicesNeedToVoyage"
                          ),
                          "label-width": "300px"
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.vesselVoyage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "vesselVoyage", $$v)
                              },
                              expression: "form.vesselVoyage"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                            ]),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    attrs: { disabled: !_vm.isEdit },
                    model: {
                      value: _vm.loadingPortCodesList,
                      callback: function($$v) {
                        _vm.loadingPortCodesList = $$v
                      },
                      expression: "loadingPortCodesList"
                    }
                  },
                  [
                    _c("label", { staticStyle: { width: "150px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.PortPortOfDepartureRange")
                        )
                      )
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNSHA" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Shanghai")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNNGB" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Ningbo")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNXMN" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Xiamen")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNSZX" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Shenzhen")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNNSA" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.NanSha")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNTAO" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Qingdao")))
                    ]),
                    _c("el-checkbox", { attrs: { label: "CNTXG" } }, [
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Tianjin")))
                    ])
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: { "label-position": "left", disabled: !_vm.isEdit }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SystemMaintenance.IsTrackingLimitedToDeparture"
                          ),
                          "label-width": "200px"
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.trackingLoadingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "trackingLoadingPort", $$v)
                              },
                              expression: "form.trackingLoadingPort"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                            ]),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.DataSettings")))
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SystemMaintenance.SynchronizationLogicSettings")
                    )
                  )
                ]),
                _c(
                  "el-checkbox-group",
                  {
                    attrs: { disabled: !_vm.isEdit },
                    model: {
                      value: _vm.synchronizationLogicSettingList,
                      callback: function($$v) {
                        _vm.synchronizationLogicSettingList = $$v
                      },
                      expression: "synchronizationLogicSettingList"
                    }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "sync-checkbox",
                        staticStyle: { display: "block" },
                        attrs: { label: "0" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.unBerthPlanDateSynETD")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "sync-checkbox",
                        staticStyle: { display: "block" },
                        attrs: { label: "1" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.estimatedArrivalTimeSynETA"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.ClearSettings")))
                ]),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { disabled: !_vm.isEdit },
                    on: { change: _vm.handleCheckboxChange },
                    model: {
                      value: _vm.form.cleanPolPortInfo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cleanPolPortInfo", $$v)
                      },
                      expression: "form.cleanPolPortInfo"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SystemMaintenance.ClearVoyageAndShipPeriodData")
                      )
                    )
                  ]
                ),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.SubscriptionScope")))
                ]),
                _c(
                  "el-tabs",
                  {
                    model: {
                      value: _vm.activeTabName,
                      callback: function($$v) {
                        _vm.activeTabName = $$v
                      },
                      expression: "activeTabName"
                    }
                  },
                  [
                    _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("SystemMaintenance.Consignor"),
                          name: "consignor"
                        }
                      },
                      [
                        _c("br"),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "100px",
                              "label-position": "left",
                              disabled: !_vm.isEdit
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("template", { slot: "label" }, [
                                  _c(
                                    "label",
                                    {
                                      staticStyle: { "font-weight": "normal" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.ConditionType"
                                          )
                                        )
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                        attrs: {
                                          title: _vm.$t(
                                            "SystemMaintenance.SelectServiceEnabledSelectEffect"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.form.pushCondition,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pushCondition", $$v)
                                      },
                                      expression: "form.pushCondition"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("SystemMaintenance.All"),
                                        value: 1
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.WhiteList"
                                        ),
                                        value: 2
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.BlackList"
                                        ),
                                        value: 3
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("SystemMaintenance.BookingAgent"),
                          name: "bookingAgent"
                        }
                      },
                      [
                        _c("br"),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "100px",
                              "label-position": "left",
                              disabled: !_vm.isEdit
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("template", { slot: "label" }, [
                                  _c(
                                    "label",
                                    {
                                      staticStyle: { "font-weight": "normal" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.ConditionType"
                                          )
                                        )
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                        attrs: {
                                          title: _vm.$t(
                                            "SystemMaintenance.SelectServiceEnabledSelectEffect"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.form.pushConditionBa,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "pushConditionBa",
                                          $$v
                                        )
                                      },
                                      expression: "form.pushConditionBa"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("SystemMaintenance.All"),
                                        value: 1
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.WhiteList"
                                        ),
                                        value: 2
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.BlackList"
                                        ),
                                        value: 3
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.form.pushCondition !== 1 &&
                    _vm.activeTabName === "consignor") ||
                  (_vm.form.pushConditionBa !== 1 &&
                    _vm.activeTabName === "bookingAgent"),
                expression:
                  "((form.pushCondition !== 1 && activeTabName === 'consignor') || (form.pushConditionBa !== 1 && activeTabName === 'bookingAgent'))"
              }
            ],
            staticClass: "grid-wrapper"
          },
          [
            _c(
              "div",
              { staticClass: "screen-btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { disabled: !_vm.isEdit, type: "primary" },
                    on: { click: _vm.addCustomerEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { disabled: !_vm.isEdit, type: "danger" },
                    on: { click: _vm.delCustomEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                )
              ],
              1
            ),
            _c("cargo-ag-grid", {
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                  _vm.gridApi.sizeColumnsToFit()
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.CloseOpen")))
            ]),
            _c(
              "div",
              { staticClass: "screen-btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { disabled: !_vm.isEdit, type: "primary" },
                    on: { click: _vm.addBranch }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { disabled: !_vm.isEdit, type: "danger" },
                    on: { click: _vm.delBranch }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                )
              ],
              1
            ),
            _c("cargo-ag-grid", {
              attrs: {
                "grid-options": _vm.gridOptions2,
                "column-defs": _vm.columnDefs2,
                "row-data": _vm.rowData2
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi2 = params.api
                  _vm.gridApi2.sizeColumnsToFit()
                }
              }
            })
          ],
          1
        )
      ]),
      _c("subscribe-port-push-rule-customer-dialog", {
        attrs: {
          title: _vm.title,
          visible: _vm.ruleViewVisible,
          customers: _vm.portDataSubscribeConfigCompanyList
        },
        on: {
          "update:visible": function($event) {
            _vm.ruleViewVisible = $event
          },
          saveCallBack: _vm.saveCallBackFunc,
          close: function($event) {
            _vm.ruleViewVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }